export { LogoFinsightStandart } from '@dealroadshow/uikit-logo/Finsight/Standart';
